/**
 * Searching manifests to declare on an episodic event, shared by the API that
 * answers the search and the dialog that sends it.
 */

/** Shorter prefixes match too much of a facility's history to be worth running. */
export const EPISODIC_CANDIDATE_SEARCH_MIN_LENGTH = 3;

/** The most manifests one search answers; a longer prefix narrows the rest. */
export const EPISODIC_CANDIDATE_SEARCH_LIMIT = 50;

export function episodicCandidateSearchTooShort(search: string): boolean {
  const trimmed = search.trim();
  return trimmed.length > 0 && trimmed.length < EPISODIC_CANDIDATE_SEARCH_MIN_LENGTH;
}
